// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"40f5dbd1","977":"a15f7815"}[chunkId] + ".chunk.js";
};